module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_7005.c079b8f9.png";